<template>
  <div v-if="data" class="card-deposito-container">
    <!-- Footer -->
    <div class="card-footer-container">
      <div class="flex-column">
        <p class="product-name">
          {{
            getSafe(data.mitra, "mitra_profile.nama_organisasi_perusahaan") ||
            "-"
          }}
        </p>
        <p class="product-address">{{ kota + ", " + provinsi }}</p>
      </div>
      <div class="flex-row" style="flex-wrap: wrap;">
        <button v-if="data.automatic_roll_over" class="product-badge">ARO</button>
        <button v-if="data.akad && data.akad.name" class="product-badge">{{ data.akad.name }}</button>
      </div>
      <div class="flex-row containerr">
        <div class="flex-column">
          <p class="product-name">
            {{ (data.category && data.category.name) || "-" }}
          </p>
          <p class="product-address product-name-label">
            {{ data.nama_produk || "-" }}
          </p>
        </div>
        <div class="flex-row">
          <img class="icon-style" :src="HeartIcon" alt="heart" />
          <img class="icon-style" :src="ShareIcon" alt="share" />
        </div>
      </div>
    </div>

    <!-- Header -->
    <div class="card-header-container">
      <div class="flex-row gap-footer-child">
        <div v-if="data.equal_rate" class="flex-column">
          <p class="white-text">{{ durasiDeposito }}</p>
          <p class="head-text">{{ $formatPersen(data.equal_rate) }}% <span style="font-size: 20px;">p.a.</span></p>
        </div>
        <div v-if="data.nisbah" class="flex-column">
          <p class="white-text">Nisbah</p>
          <p class="head-text">{{data.nisbah}}</p>
        </div>
      </div>
      <!-- <div class="flex-column" style="align-items: center"> ->> add this line if want the currency set to middle -->
      <div class="flex-column">
          <p class="white-text">Minimum Deposito</p>
          <p class="head-text">{{ $formatRupiah(data.min_initial_deposit || 0) }}</p>
      </div>
      <button class="button-blue" @click="goToDetail">Ajukan Sekarang</button>
    </div>
  </div>

  <!-- Loading fallback -->
  <div v-else class="card-deposito-container loading">
    <p class="loading-text">Memuat data produk...</p>
  </div>
</template>

<script>
import HeartIcon from "@/assets/images/landing_page/ic-heart.png";
import ShareIcon from "@/assets/images/landing_page/ic-share.png";

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      HeartIcon,
      ShareIcon,
      provinsi: "-",
      kota: "-",
    };
  },
  watch: {
    data: {
      handler(val) {
        const profile = val && val.mitra && val.mitra.mitra_profile;
        if (profile && profile.provinsi && profile.kota) {
          this.fetchNamaWilayah(profile);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    durasiDeposito() {
      const name =
        this.data && this.data.sub_category && this.data.sub_category.name;
      return name ? name.replace(/^Deposito\s*/i, "") : "-";
    },
  },
  methods: {
    async fetchNamaWilayah(profile) {
      try {
        const [prov, kota] = await Promise.all([
          this.$getNamaWilayah("provinsi", profile.provinsi),
          this.$getNamaWilayah("kota", profile.kota),
        ]);
        this.provinsi = (prov && prov.name) || "-";
        this.kota = (kota && kota.name) || "-";
      } catch (e) {
        console.error("Gagal ambil wilayah:", e);
      }
    },
    goToDetail() {
      if (this.data && this.data.id) {
        this.$router.push({ path: "/list-produk-deposito-detail", query: { id: this.data.id } });
      }
    },
    getSafe(obj, path) {
      return path
        .split(".")
        .reduce((o, key) => (o && o[key] !== undefined ? o[key] : null), obj);
    },
  },
};
</script>

<style scoped>
@media (max-width: 767px) {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  .loading-text {
    font-size: 1rem;
    color: #999;
  }
  .card-deposito-container {
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  }
  .card-header-container {
    background-color: #13346c;
    padding: 10px 20px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #13346c;
  }
  .inner-container {
    display: flex;
    flex-direction: column;
  }
  .card-footer-container {
    background-color: white;
    padding: 10px 20px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #13346c;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    gap: 10px;
  }
  .white-text {
    font-size: 14px !important;
    color: white;
    margin-bottom: 0px;
  }
  .head-text {
    font-size: 18px !important;
    font-weight: 600;
    color: white;
    line-height: 100%;
  } /* Button Style */
  .button-blue {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 50px;
  }
  .button-blue:hover {
    transform: scale(105%);
  }
  .product-badge {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 15px;
  }
  .product-name {
    font-size: 16px !important;
    color: #13346c;
    font-weight: 600;
    margin-bottom: 0px;
  }
  .product-address {
    font-size: 14px !important;
    color: #13346c;
  }
  .icon-style {
    height: 20px;
    width: 20px;
  }
  .containerr {
    margin-top: 1rem;
    justify-content: space-between;
    align-items: center;
    width: 100% !important;
  }
  .gap-footer-child {
    justify-content: space-between;
  }
}

@media (max-width: 1023px) {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  .loading-text {
    font-size: 1rem;
    color: #999;
  }
  .card-deposito-container {
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  }
  .card-header-container {
    background-color: #13346c;
    padding: 10px 20px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #13346c;
  }
  .inner-container {
    display: flex;
    justify-content: space-between;
    width: 100% !important;
    align-items: center !important;
  }
  .card-footer-container {
    background-color: white;
    padding: 10px 20px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 1px solid #13346c;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    gap: 10px;
  }
  .white-text {
    font-size: 14px !important;
    color: white;
    margin-bottom: 0px;
  }
  .head-text {
    font-size: 18px !important;
    font-weight: 600;
    color: white;
    line-height: 100%;
  } /* Button Style */
  .button-blue {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 50px;
  }
  .button-blue:hover {
    transform: scale(105%);
  }
  .product-badge {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 15px;
  }
  .product-name {
    font-size: 16px !important;
    color: #13346c;
    font-weight: 600;
    margin-bottom: 0px;
  }
  .product-address {
    font-size: 14px !important;
    color: #13346c;
  }
  .icon-style {
    height: 20px;
    width: 20px;
  }
  .containerr {
    margin-top: 1rem;
    justify-content: space-between;
    align-items: center;
    width: 100% !important;
  }
  .gap-footer-child {
    justify-content: space-between;
  }
}

@media (min-width: 1024px) {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  .loading-text {
    font-size: 1rem;
    color: #999;
  }
  .product-name-label {
    font-size: 20px !important;
  }
  .card-deposito-container {
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  }
  .card-header-container {
    background-color: #13346c;
    padding: 10px 20px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    border: 1px solid #13346c;
  }
  .card-footer-container {
    background-color: white;
    padding: 0 20px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    border: 1px solid #13346c;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    gap: 10px;
  }
  .white-text {
    font-size: 24px;
    color: white;
    margin-bottom: 0px;
  }
  .head-text {
    font-size: 36px;
    font-weight: 600;
    color: white;
    line-height: 100%;
  } /* Button Style */
  .button-blue {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 50px;
  }
  .button-blue:hover {
    transform: scale(105%);
  }
  .product-badge {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 15px;
  }
  .product-name {
    font-size: 24px;
    color: #13346c;
    font-weight: 600;
    margin-bottom: 0px;
  }
  .product-address {
    font-size: 24px;
    color: #13346c;
  }
  .icon-style {
    height: 20px;
    width: 20px;
  }
  .containerr {
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .gap-footer-child {
    flex-direction: column !important;
  }
}
@media (min-width: 1440px) {
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 200px;
  }
  .loading-text {
    font-size: 1rem;
    color: #999;
  }
  .card-deposito-container {
    border-radius: 15px;
    display: flex;
    flex-direction: column;
  }
  .card-header-container {
    background-color: #13346c;
    padding: 10px 20px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    border: 1px solid #13346c;
  }
  .inner-container {
    display: flex;
    justify-content: space-between;
    width: 60% !important;
    align-items: center !important;
  }
  .card-footer-container {
    background-color: white;
    padding: 0 20px;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    border: 1px solid #13346c;
  }
  .flex-column {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    gap: 15px;
  }
  .white-text {
    font-size: 24px;
    color: white;
    margin-bottom: 0px;
  }
  .head-text {
    font-size: 48px;
    font-weight: 600;
    color: white;
    line-height: 100%;
  } /* Button Style */
  .button-blue {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 50px;
    width: fit-content;
    display: flex;
    justify-self: end;
  }
  .button-blue:hover {
    transform: scale(105%);
  }
  .product-badge {
    padding: 15px 25px;
    background-color: #00a1ca;
    color: white;
    font-weight: 600;
    transition: all 0.5s;
    border: none;
    border-radius: 15px;
  }
  .product-name {
    font-size: 24px;
    color: #13346c;
    font-weight: 600;
    margin-bottom: 0px;
  }
  .product-address {
    font-size: 24px;
    color: #13346c;
  }
  .icon-style {
    height: 20px;
    width: 20px;
  }
  .containerr {
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .gap-footer-child {
    gap: 10% !important;
    flex-direction: row !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing-page/cardProductDepostio.vue